export default __webpack_public_path__ + "static/media/Image 3.6e739833.png";